import Repository from "../../repository";

export default {
    Report: (payload) => Repository.post(`/api/LightingMaintenanceOthers/Report`, payload),
    ReportTotal: (payload) => Repository.post(`/api/LightingMaintenanceOthers/ReportTotal`, payload),
    Chart: (payload) => Repository.post(`/api/LightingMaintenanceOthers/Chart`, payload),
}
